const locaisEmbarquePorCidadeTurissulpassagens = [
    {
        idCidadeOrigem: 5189,
        nomeCidadeOrigemComUF: 'Tubarão-SC',
        nomeCidadeOrigemComUFNormalizado: 'tubarao-sc',
        linkGoogleMaps: 'https://maps.app.goo.gl/on6NoYTxAPnk357R9',
        ordem: 1
    },
    {
        idCidadeOrigem: 5002,
        nomeCidadeOrigemComUF: 'Florianópolis-SC',
        nomeCidadeOrigemComUFNormalizado: 'florianopolis-sc',
        linkGoogleMaps: 'https://maps.app.goo.gl/8osfcUD7Kzpx6dLc9',
        ordem: 2
    },
    {
        idCidadeOrigem: 4942,
        nomeCidadeOrigemComUF: 'Balneário Camboriú-SC',
        nomeCidadeOrigemComUFNormalizado: 'balneariocamboriu-sc',
        linkGoogleMaps: 'https://maps.app.goo.gl/LLNS1u5igEvr8dpy8',
        ordem: 3
    },
    {
        idCidadeOrigem: 5040,
        nomeCidadeOrigemComUF: 'Itajaí-SC',
        nomeCidadeOrigemComUFNormalizado: 'itajai-sc',
        linkGoogleMaps: 'https://maps.app.goo.gl/15N5775VYFJGga7s8',
        ordem: 4
    },
    {
        idCidadeOrigem: 5108,
        nomeCidadeOrigemComUF: 'Balneário Piçarras-SC',
        nomeCidadeOrigemComUFNormalizado: 'balneariopicarras-sc',
        linkGoogleMaps: 'https://maps.app.goo.gl/riSWfHrwhvQmn4a27',
        ordem: 5
    },
    {
        idCidadeOrigem: 5848,
        nomeCidadeOrigemComUF: 'São Paulo-SP',
        nomeCidadeOrigemComUFNormalizado: 'saopaulo-sp',
        linkGoogleMaps: 'https://maps.app.goo.gl/URWBmMhibau4D6CV6',
        ordem: 6
    },
    {
        idCidadeOrigem: 5500,
        nomeCidadeOrigemComUF: 'Guarulhos-SP',
        nomeCidadeOrigemComUFNormalizado: 'guarulhos-sp',
        linkGoogleMaps: 'https://maps.app.goo.gl/zeArXuvPzUmKumqbA',
        ordem: 7
    },
    {
        idCidadeOrigem: 5673,
        nomeCidadeOrigemComUF: 'Osasco-SP',
        nomeCidadeOrigemComUFNormalizado: 'osasco-sp',
        linkGoogleMaps: 'https://maps.app.goo.gl/wQAbfaJj6VWuvXxi6',
        ordem: 8
    },
    {
        idCidadeOrigem: null,
        nomeCidadeOrigemComUF: 'Taboão da Serra-SP',
        nomeCidadeOrigemComUFNormalizado: 'tabaodaserra-sp',
        linkGoogleMaps: 'https://maps.app.goo.gl/kdz7kjL7Gw9uBMHEA',
        ordem: 9
    },
    {
        idCidadeOrigem: 4045,
        nomeCidadeOrigemComUF: 'São José dos Pinhais-PR',
        nomeCidadeOrigemComUFNormalizado: 'saojosedospinhais-pr',
        linkGoogleMaps: 'https://maps.app.goo.gl/iun78W1bkqX7vLSTA',
        ordem: 10
    },
    {
        idCidadeOrigem: 4946,
        nomeCidadeOrigemComUF: 'Barra Velha-SC',
        nomeCidadeOrigemComUFNormalizado: 'barravelha-sc',
        linkGoogleMaps: 'https://maps.app.goo.gl/CEYFURHVbHEoMjY86',
        ordem: 11
    },
    {
        idCidadeOrigem: 5051,
        nomeCidadeOrigemComUF: 'Joinville-SC',
        nomeCidadeOrigemComUFNormalizado: 'joinville-sc',
        linkGoogleMaps: 'https://maps.app.goo.gl/CZLJNzRWyXxYaEXc6',
        ordem: 12
    },
    {
        idCidadeOrigem: 3788,
        nomeCidadeOrigemComUF: 'Curitiba-PR',
        nomeCidadeOrigemComUFNormalizado: 'curitiba-pr',
        linkGoogleMaps: 'https://maps.app.goo.gl/BHPHFcUepaGc4Srk9',
        ordem: 13
    },
    {
        idCidadeOrigem: 5844,
        nomeCidadeOrigemComUF: 'São Lourenço da Serra-SP',
        nomeCidadeOrigemComUFNormalizado: 'saolourencodaserra-sp',
        linkGoogleMaps: 'https://maps.app.goo.gl/97acivVAgcEXRd266',
        ordem: 14
    },
    {
        idCidadeOrigem: 5763,
        nomeCidadeOrigemComUF: 'Registro-SP',
        nomeCidadeOrigemComUFNormalizado: 'registro-sp',
        linkGoogleMaps: 'https://maps.app.goo.gl/grSLnwky7yS5eVek9',
        ordem: 15
    }
];

export default locaisEmbarquePorCidadeTurissulpassagens;
